import React, { useContext, useRef } from "react";
import { formContext } from "../../routes/routes";
import { showOnSelect, showOnHide } from "./renderFunction";
import { useParams } from "react-router";
export const Radio = ({
  label = "",
  type = "radio",
  name = "",
  options = [],
  defaultValue = "",
  css = {},
  register,
  errors,
  validation,
  id,
  condtionalLabel = "",
  radioPosition = "",
  hide = false,       
  requiredLable = false,
}) => {
  const schemaContext = useContext(formContext);
  const params = useParams();
  const storedData = JSON.parse(localStorage.getItem(params.applicationID)) || {};
  const resolvedDefaultValue = storedData[name] ?? defaultValue;

  if (!Array.isArray(options)) {
    throw new Error(`Accepted radio options as Array but got ${typeof options}`);
  }

  if (hide) return null;

  return (
    <>
      {label && (
        <label className="form-label">
          {label}
          {requiredLable && <sup className="text-danger">*</sup>}
        </label>
      )}

      {condtionalLabel && (
        <label
          className="form-label"
          style={{ color: "#0079C2", fontWeight: 600, fontSize: 17 }}
        >
          {condtionalLabel}
        </label>
      )}

      <div className="row">
        {options.map((option, index) => {
          const optionId = `${name}-${index}`;
          return (
            <div key={index} className="col-md-6 mb-3">
              <div className="form-check d-flex align-items-start">
                <input
                  id={optionId}
                  className="form-check-input input-radio mt-1"
                  style={css}
                  type={type}
                  value={option.value}
                  defaultChecked={resolvedDefaultValue === option.value}
                  {...register(name, validation)}
                  onClick={(e) => {
                    showOnSelect(
                      e,
                      option.showOnSelect,
                      option.show,
                      schemaContext,
                      params.applicationID
                    );
                    showOnHide(
                      e,
                      option.showOnHide,
                      option.show,
                      schemaContext,
                      params.applicationID
                    );
                  }}
                />

                <div className="d-flex flex-column ms-2">
                  <label className="form-check-label" htmlFor={optionId}>
                    {option.label}
                  </label>

                  {option.description && (
                    <small className="text-muted">
                      {option.description}
                    </small>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {errors?.[name] && (
        <span className="text-danger">
          Select a value for {name}
        </span>
      )}

      <div id={`conditionalAreaRadio${name}`} />
    </>
  );
};
